import { render, staticRenderFns } from "./CountryBadge.vue?vue&type=template&id=23efc755&scoped=true"
import script from "./CountryBadge.vue?vue&type=script&lang=js"
export * from "./CountryBadge.vue?vue&type=script&lang=js"
import style0 from "./CountryBadge.vue?vue&type=style&index=0&id=23efc755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efc755",
  null
  
)

export default component.exports